export const REQUEST_FAQ = 'REQUEST_FAQ';
export const RECEIVE_FAQ = 'RECEIVE_FAQ';
export const RECEIVE_1PAGE_FAQ = 'RECEIVE_1PAGE_FAQ';
export const FAQ_PAGE_COUNT = 20;
